import { ImageWidget } from "./ImageWidget"

export const fields = ({ bucket }: any) => ({ image: ImageWidget({ bucket }) })
